/// Gigabytes, the way a size is weighed when choosing a version.
export function formatSize(bytes: number | undefined): string | undefined {
  if (!bytes || bytes <= 0) {
    return undefined;
  }

  const value = bytes / 1024 / 1024 / 1024;

  return value >= 10 ? `${Math.round(value)} GB` : `${value.toFixed(1)} GB`;
}
